import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { OrderBumpModal } from './OrderBumpModal';
export function PricingSection() {
  const [selectedPack, setSelectedPack] = useState<'basic' | 'pro'>('pro');
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <section id="pricing" className="w-full py-24 px-4 sm:px-6 lg:px-8 flex flex-col items-center relative overflow-hidden" style={{
    background: 'linear-gradient(180deg, #080c24 0%, #0d1333 50%, #080c24 100%)'
  }} data-id="element-251">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full opacity-[0.03] pointer-events-none" style={{
      background: 'radial-gradient(circle, #00D4FF 0%, transparent 70%)'
    }} data-id="element-252" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="w-full max-w-3xl flex flex-col items-center relative z-10" data-id="element-253">
        <div className="text-brand-cyan text-[10px] font-bold tracking-[0.3em] uppercase mb-4" data-id="element-254">
          Acceso inmediato
        </div>
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-white text-center mb-3 tracking-tight" data-id="element-255">
          Elegí tu <span className="text-brand-cyan" data-id="element-256">MegaPack</span>
        </h2>
        <p className="text-gray-500 text-sm mb-10 text-center" data-id="element-257">
          Pago único. Sin suscripciones. Tuyo para siempre.
        </p>

        <div className="w-full flex flex-col gap-3 mb-8" data-id="element-258">
          <div onClick={() => setSelectedPack('basic')} className={`w-full rounded-xl p-5 cursor-pointer transition-all duration-300 flex items-start gap-4 ${selectedPack === 'basic' ? 'border-2 border-brand-cyan/50 shadow-[0_0_35px_rgba(0,212,255,0.15),0_0_15px_rgba(0,212,255,0.08)]' : 'border border-white/10 hover:border-brand-cyan/25 hover:shadow-[0_0_20px_rgba(0,212,255,0.06)]'}`} style={{
          background: selectedPack === 'basic' ? 'linear-gradient(135deg, #101840 0%, #0d1333 100%)' : 'linear-gradient(135deg, #0a0f2e 0%, #080c24 100%)'
        }} data-id="element-259">
            <div className="shrink-0 mt-1" data-id="element-260">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all duration-200 ${selectedPack === 'basic' ? 'border-brand-cyan shadow-[0_0_10px_rgba(0,212,255,0.4)]' : 'border-gray-700'}`} data-id="element-261">
                {selectedPack === 'basic' && <div className="w-2.5 h-2.5 rounded-full bg-brand-cyan shadow-[0_0_6px_rgba(0,212,255,0.6)]" data-id="element-262" />}
              </div>
            </div>
            <div className="flex-grow flex flex-col sm:flex-row sm:items-start justify-between gap-3" data-id="element-263">
              <div className="flex flex-col" data-id="element-264">
                <h3 className="text-sm sm:text-base font-bold text-white mb-0.5 flex items-center gap-2" data-id="element-265">
                  <span data-id="element-266">🛡️</span> MEGA PACK CUENTA BLINDADA
                </h3>
                <p className="text-gray-500 text-xs" data-id="element-267">6 Tomos + 6 Bonos</p>
                <p className="text-brand-cyan/70 text-[11px] font-medium mt-1" data-id="element-268">
                  Ideal para: Quienes quieren blindar sus cuentas de forma
                  completa
                </p>
              </div>
              <div className="flex flex-col items-start sm:items-end shrink-0" data-id="element-269">
                <span className="text-red-400/80 text-[9px] font-extrabold uppercase tracking-wider border border-red-400/20 bg-red-400/10 px-1.5 py-0.5 rounded mb-1" data-id="element-270">
                  50% OFF
                </span>
                <span className="text-gray-600 line-through text-[11px]" data-id="element-271">
                  $39.998
                </span>
                <span className="text-xl sm:text-2xl font-extrabold text-white leading-tight" data-id="element-272">
                  $19.999
                </span>
                <span className="text-gray-500 text-[10px] uppercase tracking-wider" data-id="element-273">
                  ARS
                </span>
              </div>
            </div>
          </div>

          <div onClick={() => setSelectedPack('pro')} className={`w-full rounded-xl p-5 cursor-pointer transition-all duration-300 flex items-start gap-4 relative ${selectedPack === 'pro' ? 'border-2 border-brand-cyan/50 shadow-[0_0_35px_rgba(0,212,255,0.15),0_0_15px_rgba(0,212,255,0.08)]' : 'border border-white/10 hover:border-brand-cyan/25 hover:shadow-[0_0_20px_rgba(0,212,255,0.06)]'}`} style={{
          background: selectedPack === 'pro' ? 'linear-gradient(135deg, #101840 0%, #0d1333 100%)' : 'linear-gradient(135deg, #0a0f2e 0%, #080c24 100%)'
        }} data-id="element-274">
            <div className="absolute -top-2.5 right-4 bg-brand-cyan text-black text-[9px] font-extrabold uppercase tracking-wider px-3 py-1 rounded-full" data-id="element-275">
              Más elegido
            </div>
            <div className="shrink-0 mt-1" data-id="element-276">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all duration-200 ${selectedPack === 'pro' ? 'border-brand-cyan shadow-[0_0_10px_rgba(0,212,255,0.4)]' : 'border-gray-700'}`} data-id="element-277">
                {selectedPack === 'pro' && <div className="w-2.5 h-2.5 rounded-full bg-brand-cyan shadow-[0_0_6px_rgba(0,212,255,0.6)]" data-id="element-278" />}
              </div>
            </div>
            <div className="flex-grow flex flex-col sm:flex-row sm:items-start justify-between gap-3" data-id="element-279">
              <div className="flex flex-col" data-id="element-280">
                <h3 className="text-sm sm:text-base font-bold text-white mb-0.5 flex items-center gap-2" data-id="element-281">
                  <span data-id="element-282">🏆</span> MEGA PACK + SERIE BLACK
                </h3>
                <p className="text-gray-500 text-xs" data-id="element-283">
                  6 Tomos + 6 Bonos + Serie Black completa
                </p>
                <p className="text-brand-cyan/70 text-[11px] font-medium mt-1" data-id="element-284">
                  Ideal para: Quienes quieren privacidad extrema y anonimato
                  total
                </p>
              </div>
              <div className="flex flex-col items-start sm:items-end shrink-0" data-id="element-285">
                <span className="text-red-400/80 text-[9px] font-extrabold uppercase tracking-wider border border-red-400/20 bg-red-400/10 px-1.5 py-0.5 rounded mb-1" data-id="element-286">
                  50% OFF
                </span>
                <span className="text-gray-600 line-through text-[11px]" data-id="element-287">
                  $55.998
                </span>
                <span className="text-xl sm:text-2xl font-extrabold text-brand-cyan leading-tight" data-id="element-288">
                  $27.999
                </span>
                <span className="text-gray-500 text-[10px] uppercase tracking-wider" data-id="element-289">
                  ARS
                </span>
              </div>
            </div>
          </div>
        </div>

        <motion.button onClick={() => setIsModalOpen(true)} whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="w-full font-extrabold text-base sm:text-lg py-4 px-8 rounded-xl transition-all duration-300 uppercase tracking-wide text-black block text-center" style={{
        background: '#FF9900',
        boxShadow: '0 0 30px rgba(255,153,0,0.3), 0 4px 15px rgba(0,0,0,0.3)'
      }} onMouseEnter={e => {
        e.currentTarget.style.background = '#e68a00';
        e.currentTarget.style.boxShadow = '0 0 35px rgba(255,153,0,0.5), 0 4px 15px rgba(0,0,0,0.3)';
      }} onMouseLeave={e => {
        e.currentTarget.style.background = '#FF9900';
        e.currentTarget.style.boxShadow = '0 0 30px rgba(255,153,0,0.3), 0 4px 15px rgba(0,0,0,0.3)';
      }} data-id="element-290">
          Quiero mi MegaPack →
        </motion.button>

        <div className="flex flex-wrap justify-center gap-3 sm:gap-6 text-[10px] sm:text-xs text-gray-500 font-medium mt-8" data-id="element-291">
          <span className="flex items-center gap-1.5" data-id="element-292">🔒 Pago seguro</span>
          <span className="flex items-center gap-1.5" data-id="element-293">⚡ Acceso en 5 min</span>
          <span className="flex items-center gap-1.5" data-id="element-294">🛡️ Garantía 7 días</span>
          <span className="flex items-center gap-1.5" data-id="element-295">
            💳 Mercado Pago · Tarjeta · Transferencia
          </span>
        </div>
      </motion.div>

      <OrderBumpModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} selectedPack={selectedPack} data-id="element-296" />
    </section>;
}